import {
  TOrderCreate,
} from '@/types/order.ts';

const strategy: Record<TOrderCreate['target']['strategy'], string> = {
  weight: 'Masa',
  quantity: 'Sztuki',
};

export default strategy;
